// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import AISolutionsReceptionistChatPage from "../pages/AISolutionsReceptionistChat/AISolutionsReceptionistChat";
const __wvcRoutePaths = ["/AISolutionsReceptionistChatPage", "/ai-solutions-receptionist-chat"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["about", "aboutpage", "ai-optimization-services", "ai-solutions-receptionist-chat", "aioptimizationservicespage", "aisolutionsreceptionistchatpage", "analytics-reporting", "analyticsreportingpage", "appointment-booking-systems", "appointmentbookingsystemspage", "business-automations", "businessautomationspage", "contact", "contactpage", "crm-lead-management", "crmleadmanagementpage", "faq", "faqpage", "generative-engine-optimization", "generativeengineoptimizationpage", "geo-vs-seo", "geovsseopage", "growth-strategy-consulting", "growthstrategyconsultingpage", "home", "homepage", "lead-generation-conversion-optimization", "leadgenerationconversionoptimizationpage", "local-seo", "local-seo-solutions", "localseopage", "localseosolutionspage", "post", "pricing", "pricing-plans", "pricingpage", "pricingplanspage", "privacy-policy", "privacypolicypage", "rebook-strategy-call", "rebookstrategycallpage", "reputation-management", "reputationmanagementpage", "services", "servicespage", "system-integrations", "systemintegrationspage", "terms-conditions", "termsconditionspage", "visibility-checkup", "visibilitycheckuppage", "website-design", "website-design-optimization", "websitedesignoptimizationpage", "websitedesignpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<AISolutionsReceptionistChatPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<AISolutionsReceptionistChatPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
